(function ($, Drupal, drupalSettings, once) {

  'use strict';

  Drupal.behaviors.weaver_views = {

    initCalendarFilterToggle: function() {
      // move filters into a collapse for < lg
      const calendarFilters = document.querySelector('.view-nvcl-calendar-events .view-filters');

      if (calendarFilters == null) {
        return;
      }

      if (window.screen.width < 1200) {
        let filterCollapse = document.getElementById('filter-collapse');
        if (filterCollapse != null) {
          filterCollapse.prepend(calendarFilters);
        }
      } else {
        document.getElementById('view-filters-wrapper').appendChild(calendarFilters);
      }
    },

    initSevenDayEventsNav: function() {
      const nav = document.getElementById('nvcl-7day-nav');
      if (nav == null) {
        return;
      }

      const buttons = nav.querySelectorAll('button');
      if (buttons.length < 1) {
        return;
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          this.sevenDayEventsNavScroll(button);
        });
      });
    },

    scrollToCalendar: function() {
      const calendar = document.querySelector('.view-nvcl-calendar-events.view-display-id-page_1');

      if (calendar == null || window.location.search == '') {
        return;
      }

      setTimeout(() => {
        calendar.scrollIntoView();
      }, 500);
    },

    sevenDayEventsNavScroll: function(button) {
      const direction = button.dataset.nvclNav;
      console.log(direction);
    },

    attach: function (context, settings) {

      const weaver_views = Drupal.behaviors.weaver_views;

      $(once('weaver_views', 'body', context)).each(function () {
          weaver_views.initCalendarFilterToggle();
          weaver_views.initSevenDayEventsNav();
          weaver_views.scrollToCalendar();
      });

      window.addEventListener('resize', () => {
        weaver_views.initCalendarFilterToggle();
      });

      ////////////////////////////////////////
      // Calendar


      // scroll to start of content if on mobile and filters used
      const calendarLeft = document.querySelector('.calendar-left');
      if (calendarLeft != null) {
        if (window.location.href.includes('?') && window.screen.width < 1200) {
          calendarLeft.scrollIntoView({
            behaviour: 'smooth',
            block: 'start'
          });
        }
      }

      /////////////////////////////////////////////
      // RESET

      // reset a form if reset button clicked
      const calendarForm = document.getElementById('views-exposed-form-nvcl-calendar-events-page-1');
      const calendarResets = document.querySelectorAll('.clear-button');


      if (calendarForm != null && calendarResets != null) {
        calendarResets.forEach((calendarReset) => {
          calendarReset.addEventListener('click', (e) => {

            // reset any text inputs and radios/checkboxes
            let formInputs = calendarForm.querySelectorAll('input');
            if (formInputs != null) {
              formInputs.forEach((formInput) => {

                formInput.value = '';
                formInput.checked = false;

              });
            }

            // reset any selects
            let formSelects = calendarForm.querySelectorAll('select');
            if (formSelects != null) {
              formSelects.forEach((formSelect) => {

                // use "All" value if exists
                if (formSelect.querySelector('option[value="All"]') != null) {
                  formSelect.value = 'All';
                } else {
                  formSelect.value = '';
                }

              });
            }

          });
        });
      }
    }
  };

})(jQuery, Drupal, drupalSettings, once);
